import { Menu } from '@mantine/core';
import { IconAmbulance } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';

const SusMenuItem = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <Menu.Item leftSection={<IconAmbulance stroke={1.5} />} onClick={() => navigate('/sus')}>
      {t('nav.admin.sus')}
    </Menu.Item>
  );
};

export default SusMenuItem;
